import { create } from 'zustand'

export interface GlobalState {
  myUserId: number | null
  liveId: number | null
  liveUserId: number | null
  liveCountry: string | null
  token: string | null
  isStreamer: boolean
}

const readNumber = (key: string): number | null => {
  if (typeof window === 'undefined') return null
  const v = window.localStorage.getItem(key)
  return v ? Number(v) : null
}
const readString = (key: string): string | null =>
  typeof window === 'undefined' ? null : window.localStorage.getItem(key)
const readBoolean = (key: string): boolean =>
  typeof window === 'undefined' ? false : window.localStorage.getItem(key) === 'true'

export const useGlobalStore = create<GlobalState>(() => ({
  myUserId: readNumber('@myUserId'),
  liveId: readNumber('@liveId'),
  liveUserId: readNumber('@liveUserId'),
  liveCountry: readString('@liveCountry'),
  token: readString('@token'),
  isStreamer: readBoolean('@isStreamer'),
}))
